import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Plus, User } from "@phosphor-icons/react";

export default function Patients() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/patients").then((r) => setItems(r.data)); }, []);
    return (
        <div className="fade-up">
            <PageHeader
                eyebrow={`Pacientes · ${items.length}`}
                title="Pacientes"
                lead="Ficha clínica de cada paciente: perfil epigenético, objetivos, tratamientos previos, fórmulas asociadas."
                actions={
                    <Link to="/pacientes/nuevo" className="btn-primary inline-flex items-center gap-2" data-testid="patients-new-button">
                        <Plus size={14} weight="bold"/> Nuevo paciente
                    </Link>
                }
            />
            <div className="px-8 md:px-12 py-8 max-w-6xl">
                {items.length === 0 ? (
                    <div className="border hairline bg-white p-12 text-center text-[var(--ink-3)]" data-testid="patients-empty">
                        Aún no has añadido pacientes. <Link to="/pacientes/nuevo" className="text-[var(--sage)] underline">Crear el primero →</Link>
                    </div>
                ) : (
                    <div className="surface overflow-x-auto">
                        <table className="data-table w-full">
                            <thead><tr><th>Paciente</th><th>Sexo</th><th>Edad/DOB</th><th>Actividad</th><th>Objetivos</th></tr></thead>
                            <tbody>
                                {items.map((p) => (
                                    <tr key={p.id} data-testid={`patient-row-${p.id}`}>
                                        <td>
                                            <Link to={`/pacientes/${p.id}`} className="font-medium hover:text-[var(--sage)] flex items-center gap-2">
                                                <User size={16} weight="duotone" className="text-[var(--ink-3)]"/>{p.name}
                                            </Link>
                                            {p.code && <div className="text-xs mono text-[var(--ink-3)] mt-0.5">{p.code}</div>}
                                        </td>
                                        <td className="text-[var(--ink-2)]">{p.sex || "—"}</td>
                                        <td className="mono text-xs">{p.dob || "—"}</td>
                                        <td className="text-[var(--ink-2)]">{p.activity_level || "—"}</td>
                                        <td className="text-[var(--ink-2)] max-w-[260px] truncate">{(p.objectives || []).join(" · ") || "—"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}
